export default "__VITE_ASSET__BSFXmgXr__"